<template>
  <el-dialog
    append-to-body
    width="900px"
    :title="`${title} (${
      currentRow && currentRow.part_time_type == 2 ? '代招' : '直招'
    })`"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="top"
      :model="form.data"
      :rules="form.rules"
    >
      <el-row :gutter="30">
        <el-col :span="8">
          <el-form-item prop="title" label="岗位名称">
            <el-input
              v-model="form.data.title"
              placeholder="请输入"
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="job_id" label="岗位类型">
            <el-cascader
              v-model="form.data.job_id"
              :options="categoryArr"
              size="mini"
              :props="{ emitPath: true, value: 'id', label: 'name' }"
            >
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="salary" label="薪资">
            <el-input
              placeholder="请输入"
              size="mini"
              v-model="form.data.salary"
            >
              <span slot="suffix" style="line-height: 26px">元</span>
              <el-select
                v-model="form.data.salary_type"
                slot="append"
                style="min-width: 120px"
                size="mini"
                placeholder="请选择"
              >
                <el-option label="小时" :value="1"></el-option>
                <el-option label="日" :value="2"></el-option>
                <el-option label="月" :value="3"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="8">
          <el-form-item prop="education" label="学历">
            <el-select
              v-model="form.data.education"
              placeholder="请选择"
              size="mini"
            >
              <el-option
                v-for="item in education_"
                :label="item.value"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="major_id" label="专业">
            <el-select
              v-model="form.data.major_id"
              size="mini"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="item in majorArr"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="work_age" label="经验">
            <el-select
              v-model="form.data.work_age"
              placeholder="请选择"
              size="mini"
            >
              <el-option
                :label="item.value"
                :value="item.id"
                v-for="item in work_age_"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="8">
          <el-form-item prop="demand" label="岗位要求">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入用工需求标准，如形象、学历、性别、年龄等"
              v-model="form.data.demand"
              size="mini"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="duty" label="工作内容">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入"
              v-model="form.data.duty"
              size="mini"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="part_settlement_type" label="结算周期">
            <el-radio-group
              v-model="form.data.part_settlement_type"
              size="mini"
            >
              <el-radio :label="1">日结</el-radio>
              <el-radio :label="2">周结</el-radio>
              <el-radio :label="3">月结</el-radio>
              <el-radio :label="4">项目结</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="8">
          <el-form-item prop="timeType" label="招聘时长">
            {{ form.data.part_days }}天
            <!-- <el-select
              v-model="form.data.timeType"
              placeholder="请选择"
              size="mini"
            >
              <el-option
                v-for="item in part_time_amounts"
                :key="item.id"
                :label="item.days + '天'"
                :value="item.id"
              ></el-option>
            </el-select> -->
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="company_id" label="所属企业">
            <el-select
              v-model="form.data.company_id"
              placeholder="请选择"
              disabled
              @change="handleCompanyChange"
              filterable
              clearable
              size="mini"
            >
              <el-option
                v-for="item in companyList_"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="address_id" label="工作地址">
            <el-select
              v-model="form.data.address_id"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
            >
              <el-option
                v-for="item in addressList"
                :label="item.working_address"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="24" class="part_work_hour_type-class">
          <el-form-item label="用工时间">
            <template slot="label">
              <div style="display: flex">
                <div style="margin-right: 10px">用工时间</div>
                <el-button type="text" @click="addTimeRow" :disabled="isEdit"
                  >添加</el-button
                >
              </div>
            </template>
            <div style="display: flex; align-items: center">
              <el-radio-group
                v-model="form.data.part_work_hour_type"
                :disabled="isEdit"
                size="mini"
              >
                <el-radio :label="1">按日期</el-radio>
                <el-radio :label="2">按星期</el-radio>
              </el-radio-group>
              <el-form-item
                label=""
                prop="part_week_over_time"
                v-if="form.data.part_work_hour_type == 2"
              >
                <el-date-picker
                  v-model="form.data.part_week_over_time"
                  type="date"
                  placeholder="选择截止日期"
                  style="width: 140px; margin-left: 10px"
                  value-format="yyyy-MM-dd"
                  :disabled="isEdit"
                  size="mini"
                ></el-date-picker>
              </el-form-item>
              <el-checkbox :disabled="detailInfo && detailInfo.part_status == 3" style="margin-left:60px" v-model="form.data.part_work_time_type" :true-label="2" :false-label="1">
                    要求全部时间到岗
                    <el-tooltip
                      content="若要求求职者全部用工时间都到岗，请勾选此项;若支持求职者自由选择用工时间段到岗,则无需勾选"
                      placement="top"
                    >
                      <i class="el-icon-warning" style="color: #e6a23c"></i>
                    </el-tooltip>
              </el-checkbox>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="form.data.part_work_hour_type == 1">
          <div class="time-rows">
            <div
              v-for="(item, index) in form.data.dateRows"
              :key="'date-' + index"
              class="time-row"
            >
              <el-form-item
                :prop="'dateRows.' + index + '.date'"
                :rules="{
                  required: true,
                  message: '请选择日期',
                  trigger: 'change',
                }"
                style="margin-bottom: 0; margin-right: 10px"
              >
                <el-date-picker
                  v-model="item.date"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  size="mini"
                  :picker-options="datePickerOptions"
                  style="width: 140px"
                  :disabled="isEdit"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                :prop="'dateRows.' + index + '.startTime'"
                :rules="{
                  required: true,
                  message: '请选择开始时间',
                  trigger: 'change',
                }"
                style="margin-bottom: 0; margin-right: 10px"
              >
                <el-time-picker
                  v-model="item.startTime"
                  placeholder="开始时间"
                  value-format="HH:mm"
                  format="HH:mm"
                  size="mini"
                  style="width: 140px"
                  :disabled="isEdit"
                ></el-time-picker>
              </el-form-item>
              <el-form-item
                :prop="'dateRows.' + index + '.endTime'"
                :rules="[
                      { required: true, message: '请选择结束时间', trigger: 'change' },
                      { validator: validateEndTime(item), trigger: 'change' }
                ]"
                style="margin-bottom: 0; margin-right: 10px"
              >
                <el-time-picker
                  v-model="item.endTime"
                  placeholder="结束时间"
                  value-format="HH:mm"
                  format="HH:mm"
                  size="mini"
                  style="width: 140px"
                  :disabled="isEdit"
                ></el-time-picker>
              </el-form-item>
              <el-form-item
                :prop="'dateRows.' + index + '.people'"
                :rules="form.peopleRules"
                style="margin-bottom: 0; margin-right: 10px"
              >
                <el-input
                  v-model="item.people"
                  placeholder="人数"
                  size="mini"
                  style="width: 120px"
                  :disabled="isEdit"
                >
                  <span slot="suffix">人</span>
                </el-input>
              </el-form-item>
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="removeDateRow(index)"
                style="color: #f56c6c"
                :disabled="isEdit"
              ></el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="24" v-if="form.data.part_work_hour_type == 2">
          <div class="time-rows">
            <div
              v-for="(item, index) in form.data.weekRows"
              :key="'week-' + index"
              class="time-row"
            >
              <el-form-item
                :prop="'weekRows.' + index + '.weekday'"
                :rules="{
                  required: true,
                  message: '请选择星期',
                  trigger: 'change',
                }"
                style="margin-bottom: 0; margin-right: 10px"
              >
                <el-select
                  v-model="item.weekday"
                  placeholder="选择星期"
                  size="mini"
                  style="width: 140px"
                  :disabled="isEdit"
                >
                  <el-option label="每周一" :value="1"></el-option>
                  <el-option label="每周二" :value="2"></el-option>
                  <el-option label="每周三" :value="3"></el-option>
                  <el-option label="每周四" :value="4"></el-option>
                  <el-option label="每周五" :value="5"></el-option>
                  <el-option label="每周六" :value="6"></el-option>
                  <el-option label="每周日" :value="7"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :prop="'weekRows.' + index + '.startTime'"
                :rules="{
                  required: true,
                  message: '请选择开始时间',
                  trigger: 'change',
                }"
                style="margin-bottom: 0; margin-right: 10px"
              >
                <el-time-picker
                  v-model="item.startTime"
                  placeholder="开始时间"
                  value-format="HH:mm"
                  format="HH:mm"
                  size="mini"
                  style="width: 140px"
                  :disabled="isEdit"
                ></el-time-picker>
              </el-form-item>
              <el-form-item
                :prop="'weekRows.' + index + '.endTime'"
                :rules="[
                      { required: true, message: '请选择结束时间', trigger: 'change' },
                      { validator: validateEndTime(item), trigger: 'change' }
                ]"
                style="margin-bottom: 0; margin-right: 10px"
              >
                <el-time-picker
                  v-model="item.endTime"
                  placeholder="结束时间"
                  value-format="HH:mm"
                  format="HH:mm"
                  size="mini"
                  style="width: 140px"
                  :disabled="isEdit"
                ></el-time-picker>
              </el-form-item>
              <el-form-item
                :prop="'weekRows.' + index + '.people'"
                :rules="form.peopleRules"
                style="margin-bottom: 0; margin-right: 10px"
              >
                <el-input
                  v-model="item.people"
                  placeholder="人数"
                  size="mini"
                  style="width: 120px"
                  :disabled="isEdit"
                >
                  <span slot="suffix">人</span>
                </el-input>
              </el-form-item>
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="removeWeekRow(index)"
                style="color: #f56c6c"
                :disabled="isEdit"
              ></el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
        <el-button @click="toggle(false)">取消</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "ReportDetail",
  mixins: [mixinTable],
  data() {
    return {
      datePickerOptions: {
        disabledDate(time) {
          const today = new Date();
          const tomorrow = new Date(today);
          tomorrow.setDate(tomorrow.getDate());
          return time.getTime() < tomorrow.getTime();
        },
      },
      detailInfo:null,
      currentRow: null,
      part_time_amounts: [],
      title: "创建",
      visible: false,
      loading: false,
      reportType: 1,
      addressList: [],
      categoryArr: [],
      companyList_: [],
      work_age_: [],
      majorArr: [],
      education_: [],
      form: {
        loading: false,
        data: {
          title: "",
          company_id: "",
          job_id: [],
          salary: "",
          salary_type: 1,
          education: "",
          major_id: "",

          work_age: "",
          demand: "",
          duty: "",
          part_settlement_type: 1,
          part_time_type: 2,
          timeType: 1,
          address_id: "",
          type: 3, //3.兼职
          part_work_hour_type: 1,
          part_week_over_time: "",
          part_work_time_type: 1,
          dateRows: [{ date: "", startTime: "", endTime: "", people: "" }],
          weekRows: [{ weekday: "", startTime: "", endTime: "", people: "" }],
        },
        rules: {
          company_id: [
            { required: true, message: "必填项", trigger: "change" },
          ],
          title: [{ required: true, message: "必填项", trigger: "change" }],
          job_id: [{ required: true, message: "必填项", trigger: "change" }],
          duty: [{ required: true, message: "必填项", trigger: "change" }],
          demand: [{ required: true, message: "必填项", trigger: "change" }],
          work_age: [{ required: true, message: "必填项", trigger: "change" }],
          education: [{ required: true, message: "必填项", trigger: "change" }],
          major_id: [{ required: true, message: "必填项", trigger: "change" }],
          part_week_over_time: [
            // { required: true, message: "", trigger: "change" },
          ],
          address_id: [
            { required: true, message: "必填项", trigger: "change" },
          ],
          salary: [{ required: true, message: "必填项", trigger: "change" }],
        },
        peopleRules: [
          { required: true, message: "请输入人数", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!value && value !== 0) {
                callback(new Error("请输入人数"));
              } else if (!Number.isInteger(Number(value))) {
                callback(new Error("人数必须是整数"));
              } else if (Number(value) < 0) {
                callback(new Error("人数必须大于等于0"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getCategory();
    this.getParamsJob();
    this.getMajor();
    this.getCompanyList();
  },
  methods: {
    getpart_time_amounts(obj) {
      this.part_time_amounts = obj;
    },
    // 获取岗位类别
    getCategory() {
      this.$http.get("common/param/category", { params: {} }).then((res) => {
        if (res.code == 1) {
          this.categoryArr = res.data;
        }
      });
    },
    addTimeRow() {
      if (this.form.data.part_work_hour_type == 1) {
        this.form.data.dateRows.push({
          date: "",
          startTime: "",
          endTime: "",
          people: "",
        });
      } else {
        this.form.data.weekRows.push({
          weekday: "",
          startTime: "",
          endTime: "",
          people: "",
        });
      }
    },
    getDetail(row, title) {
      this.currentRow = row;
      this.title = title;
      if (row.id) {
        this.$http
          .get("/admin/job/detail", { params: { id: row.id } })
          .then((res) => {
            if (res.code == 1) {
              this.detailInfo = res.data;
              this.form.data = {
                ...this.form.data,
                ...res.data,
              };
              this.getAddressList();
              //回显岗位类型
              this.form.data.job_id = [res.data.category, res.data.job_id];
              //根据part_days 回显timeType
              let timeTypeObj = this.part_time_amounts.find((v) => {
                return v.days == res.data.part_days;
              });
              if (timeTypeObj) {
                this.form.data.timeType = timeTypeObj.id;
              }
              //根据part_work_hour_type 回显dateRows 或 weekRows
              if (title == "修改") {
                // 复制不需要用工时间
                if (res.data.part_work_hour_type == 1) {
                  this.form.data.dateRows = res.data.part_work_hour.map(
                    (item) => {
                      return {
                        date: item.day,
                        startTime: item.start_time,
                        endTime: item.end_time,
                        people: item.total,
                        id: item.id,
                      };
                    }
                  );
                  this.form.data.weekRows = [
                    { weekday: "", startTime: "", endTime: "", people: "" },
                  ];
                } else {
                  this.form.data.weekRows = res.data.part_work_hour.map(
                    (item) => {
                      return {
                        weekday: item.week,
                        startTime: item.start_time,
                        endTime: item.end_time,
                        people: item.total,
                        id: item.id,
                      };
                    }
                  );
                  this.form.data.dateRows = [
                    { date: "", startTime: "", endTime: "", people: "" },
                  ];
                }
              } else {
                this.form.data.dateRows = [
                  { date: "", startTime: "", endTime: "", people: "" },
                ];
                this.form.data.weekRows = [
                  { weekday: "", startTime: "", endTime: "", people: "" },
                ];
              }
              console.log(this.form.data, "this.form.data");
            }
          });
      }
    },
    reset(done) {
      this.currentRow = null;
      this.title = "";
      this.form.data = {
        title: "",
        job_id: [],
        salary: "",
        salary_type: 1,
        education: "",
        major_id: "",
        work_age: "",
        demand: "",
        duty: "",
        part_settlement_type: 1,
        part_time_type: 2,
        timeType: 1,
        address_id: "",
        type: 3, //3.兼职
        part_work_hour_type: 1,
        part_week_over_time: "",
        part_work_time_type: 1,
        dateRows: [{ date: "", startTime: "", endTime: "", people: "" }],
        weekRows: [{ weekday: "", startTime: "", endTime: "", people: "" }],
      };
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    confirm() {
      console.log(this.form.data, "this.form.data");
      console.log(this.part_time_amounts, "this.this.part_time_amounts");
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          if(this.form.data.part_work_time_type == 2) {
            let list = this.form.data.part_work_hour_type == 1 ? this.form.data.dateRows : this.form.data.weekRows;
            let allEqual = list.every(k => k.people == list[0].people);
            if(!allEqual) {
              this.$message.error("用工时段全部到岗用工人数请保持一致");
              return;
            }
          }
          let addressItem = this.addressList.find((v) => {
            return v.id == this.form.data.address_id;
          });
          //招聘时长
          // let timeTypeObj = this.part_time_amounts.find((v) => {
          //   return v.id == this.form.data.timeType;
          // });
          // let part_days = timeTypeObj.days;
          // let part_amount = timeTypeObj.amount;
          //用工时间
          let part_work_hour_json = [];
          if (this.form.data.part_work_hour_type == 1) {
            part_work_hour_json = this.form.data.dateRows.map((v) => {
              return {
                day: v.date,
                start_time: v.startTime,
                end_time: v.endTime,
                total: v.people,
                id: v.id,
              };
            });
          } else {
            part_work_hour_json = this.form.data.weekRows.map((v) => {
              return {
                week: v.weekday,
                start_time: v.startTime,
                end_time: v.endTime,
                total: v.people,
                id: v.id,
              };
            });
          }
          let _params = {
            ...this.form.data,
            ...addressItem,
            job_id: this.form.data.job_id[1],
            category: this.form.data.job_id[0],
            id: this.currentRow?.id || "",
            // part_days,
            // part_amount,
            part_work_hour_json: JSON.stringify(part_work_hour_json),
          };
          this.form.loading = true;
          let url =
            this.title == "修改" ? "/admin/job/edit" : "/admin/job/create";
          this.$http
            .post(url, _params)
            .then((res) => {
              if (res.code == 1) {
                this.$message.success("操作成功！");
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    addTimeRow() {
      if (this.form.data.part_work_hour_type == 1) {
        this.form.data.dateRows.push({
          date: "",
          startTime: "",
          endTime: "",
          people: "",
        });
      } else {
        this.form.data.weekRows.push({
          weekday: "",
          startTime: "",
          endTime: "",
          people: "",
        });
      }
    },
    removeDateRow(index) {
      this.form.data.dateRows.splice(index, 1);
    },
    removeWeekRow(index) {
      this.form.data.weekRows.splice(index, 1);
    },
    handleCompanyChange(val) {
      if (val) {
        this.form.data.address_id = "";
        this.getAddressList();
      } else {
        this.form.data.address_id = "";
        this.addressList = [];
      }
    },
    getAddressList() {
      this.$http
        .get("/admin/company/addressList", {
          params: {
            company_id: this.form.data.company_id,
            page: 1,
            count: 1000,
          },
        })
        .then((res) => {
          if (res.code == 1) {
            this.addressList = res.data.list;
          }
        });
    },
    validateEndTime(item) {
      return (rule, value, callback) => {
        if (value && item.startTime) {
          if (value < item.startTime) {
            callback(new Error('结束时间应大于开始时间'));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
    },
  },
  computed: {
    isEdit() {
      return (
        !!this.currentRow &&
        this.currentRow.part_status == 3 &&
        this.title == "修改"
      );
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .el-form-item {
    margin-bottom: 10px;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
}
.time-rows {
  .time-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
